
import Image from "next/image";
import styles from "./ediror.module.scss";
import { HandySvg } from "handy-svg";
import { useEffect, useState } from "react";
import { getPoses } from "../../../pages/api/sportcards";

const Pose = ({ sportCardsState, setSportCardsState, setSteps }) => {
  const [poses, setPoses] = useState([]);

  useEffect(() => {
    const getPosesList = async (token) => {
      const response = await getPoses(token);
      setPoses(response.data);
    }
    getPosesList()
  }, [])

  const Next = () => {
    setSteps(prev => prev.map(step => step.name === "Background" ? { ...step, active: true } : { ...step, active: false }));
  }

  return (
    <>
      <div className={styles.posesWrapeer}>
        {poses.map((pose) => (
          <button key={pose.id} onClick={() => setSportCardsState({ ...sportCardsState, pose: pose })} className={`${styles.pose} ${pose.id === sportCardsState.pose?.id ? styles.active : ""}`}>
            <Image className={styles.poseImg} src={pose.name} alt="pose" width="140" height="233" quality={99} unoptimized />
          </button>
        ))}
      </div>
      <button onClick={Next} disabled={sportCardsState.pose === null} className={styles.nextBtn}>Next <HandySvg src={"/illustration_service/next.svg"} width={24} height={24} fill={"transparent"} /></button>
    </>

  )
}

export default Pose